import { FormControl } from '@angular/forms';
import { GroupMarketingPreferenceFormField } from './group-marketing-preference-form-field.enum';

export interface GroupMarketingPreferenceForm {
  [GroupMarketingPreferenceFormField.Email]: FormControl<boolean>;
  [GroupMarketingPreferenceFormField.Telephone]: FormControl<boolean>;
  [GroupMarketingPreferenceFormField.Post]: FormControl<boolean>;
}
